import styled, {css} from 'styled-components'
import {EventType} from '@/features/agenda/types'

export const StyledAgendaUnavailabilityEvent = styled.div(
    ({theme: {palette}}) => css`
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        height: 100%;
        background: repeating-linear-gradient(
            -45deg,
            ${palette.neutral['100']} 0px,
            ${palette.neutral['100']} 10px,
            transparent 10px,
            transparent 20px
        );
    `
)

export const StyledAgendaBlockoutEvent = styled.div<{
    $absenceType: Exclude<EventType, 'event'>
}>(
    ({theme: {palette, typography}, $absenceType}) => css`
        ${typography.textSm};
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        height: 100%;
        text-align: center;
        background: repeating-linear-gradient(
            -45deg,
            ${$absenceType == 'consultant_absence' ? palette.purple['100'] : palette.orange['50']} 0px,
            ${$absenceType == 'consultant_absence' ? palette.purple['100'] : palette.orange['50']} 10px,
            transparent 10px,
            transparent 20px
        );
        color: ${$absenceType == 'patient_absence'
            ? palette.orange['500']
            : $absenceType == 'consultant_absence'
              ? palette.purple['500']
              : palette.neutral['500']};
        text-transform: uppercase;
        font-weight: 500;
    `
)
